import { createFileRoute } from "@tanstack/react-router";
import { TicketDetailPage } from "@/components/pages/TicketDetailPage";

export const Route = createFileRoute("/tickets/$ticketId")({
  component: TicketDetailPage,
});
